<script lang="ts">
    import { onMount, getContext } from 'svelte';
    import { parse, parseISO, format, isValid } from 'date-fns';
    import { zonedTimeToUtc } from 'date-fns-tz';

    import { _ } from 'svelte-i18n';
    import { format_duration, format_duration_msf, parse_duration, validate_duration} from './time'
    import ParticipantList from './ParticipantList.svelte';
    import Select from 'svelte-select';
    import { get, type Writable } from 'svelte/store';
    import MyInput from './MyInput.svelte';
    
    export let session_id, template_id;
    export let start_date, end_date, repeat_type, sharing_type, allowed_users, members, is_group_session;
    export let invited_users, users_to_invite, users_to_schedule, community;
    export let is_zoom_media, zoom_autocreation, zoom_url;

    export let owner;
    export let is_owner: boolean;

    // NOTE: this svelte component is not being used, can probably delete it.

    export function checkValidity() {
      if (is_group_session) {
        if(selected_community == null) {
          selected_community_input.setCustomValidity($_("sessions.errors.required_input"));
          setTimeout(()=> session_form.reportValidity(), 0);
          return false;
        }
        else if(selected_community != null) {
          selected_community_input.setCustomValidity("");
        }
      }
      let val = session_form.checkValidity();
      if (!val) {
        // Switch to Details tab to show invalid input messages..
        //tab = 0;
        setTimeout(()=> session_form.reportValidity(), 0);
      }
      return val;
    }

    let session_form: HTMLFormElement;

    //let tab=0;

    let xert: any = getContext('xert');

    let dateString = (date: Date) => isValid(date) ? format(date, 'yyyy-LL-dd') : "";
    let timeString = (date: Date) => format(date, 'HH:mm');
    function parseDateAndTime(date_string, time_string) {
        let dateAndTime = new Date('');
        let date = parseISO(date_string);
        if (!isValid(date)) return date;

        let timeFormats = [
        'HH', // 24 hour;
        'HH:mm',
        'hha',
        'hh:mma',
        ]
        time_string = time_string.replace(/\s/g, ''); // Remove whitespace with regex
        timeFormats.every(fmt=>{
        dateAndTime = parse(time_string, fmt, date);
        return !isValid(dateAndTime);
        });
        return dateAndTime;
    }

    // NOTE: datetime-local not yet implemented in some browsers,
    // https://html.spec.whatwg.org/multipage/input.html#local-date-and-time-state-(type=datetime-local)
    // https://caniuse.com/input-datetime
    // e.g. Firefox requires dom.forms.datetime.timepicker flag that isn't enabled by default.

    let start_date_obj = parseISO(start_date);
    let input_date: string = dateString(start_date_obj);
    let input_time: string = timeString(start_date_obj);

    let clubs: Writable<[any]> = getContext('clubs');

    let club_items = [];
    $: club_items = ($clubs).map((c)=>{
        let type = $_("clubs."+c.type);
        return {
        label: c.display_name,
        value: c.id,
        group: type,
        }
    });

    let club_users = [];
    let can_create_public = false;
    let club_is_selected = false;
    function fetch_club_details(club_id) {
        // Reset all club related fields.
        console.log(`====> fetch_club_details: ${club_id}`);
        club_users = [];
        can_create_public = false;
        club_is_selected = false;
        if (club_id == null) {
        sharing_type = null;
        return;
        }
        window.fetch(`${xert.Sessions.urls.clubs}/${club_id}`, {
            ...getContext('fetch-request'),
        })
        .then(r=>r.json())
        .then(club_details=>{
        // Allow either owner, coach or squad member to make public sessions.
        can_create_public = club_details.is_owner || club_details.is_coach || club_details.is_squad_member;
        if (sharing_type == null || (sharing_type == "public" && !can_create_public)) {
            sharing_type = "community";
        }

        club_users = club_details?.users ?? [];
        club_is_selected = true;
        });
    }

    const original_invited_users = allowed_users ?? [];
    users_to_invite = [...original_invited_users];
    const original_scheduled_users = (members ?? []).map(u=>u.id);
    users_to_schedule = [...original_scheduled_users];
    //$: selected_club = ($clubs).find(v=>v.id == session.community);
    $: fetch_club_details(community);

    function combine_users(_owner, invited, scheduled, club) {
        console.log("combine_users called!");
        let sort = v=>v.sort((a, b)=> a.last_name.localeCompare(b.last_name));
        let users = sort([...scheduled]);
        let ids = users.map(u=>u.id);
        [...(_owner?.first_name != null ? [_owner] : []), ...sort((invited ?? [])), ...sort((club ?? []))].forEach(u => {
        if (!ids.includes(u.id)) {
            users.push(u);
            ids.push(u.id);
        }
        });
        return [...users.values()];
    } 
    $: is_public = sharing_type == "public";
    $: allow_edit_users = sharing_type == "invite-only";

    function reset_invited_users(){
        users_to_schedule = [...original_scheduled_users]
        users_to_invite = [...original_invited_users];
    }

    // Clear community input if set to non-group-session.
    let selected_community = community == null ? undefined : club_items.find(v=>v.value==community);
    let selected_community_input;
    function initCommunity(_club_items) {
        let val = _club_items.find(v=>v.value==community);
        if (val != null) {
        selected_community = val;
        }
    }
    $: if (community != null) initCommunity(club_items);
    //$: if (is_group_session && community != null) session.community = community.value;
    $: if (is_group_session && selected_community != null) community = selected_community.value;

    let params = getContext('user_params');

    let session_type_items = [
        { label: "Group", value: "group", },
        { label: "Solo", value: "solo", },
    ];
    let selected_session_type = is_group_session ? session_type_items[0] : session_type_items[1];
    $: is_group_session = selected_session_type.value == "group";

    $: is_zoom_media = is_group_session && (zoom_autocreation || zoom_url);
    $: if (zoom_autocreation) {
        zoom_url = null;
    }
    let is_zoom_authorized;
    onMount(async() => {
        // First time check
        window.fetch(`${xert.Sessions.urls.is_zoom_authorized}`, {
        method: 'get',
        credentials: "same-origin",
        })
        .then(response => response.json())
        .then(data => {
        is_zoom_authorized = data.is_zoom_authorized;
        if (zoom_autocreation === null || zoom_autocreation === undefined) {
            zoom_autocreation = false; // zoom autocreation false by default
        }
        }).catch(error=>{
        console.log(error)
        });
    });

    // Combine separate date and time inputs into datetime string.
    // NOTE: This should be in the user's local timezone
    $: input_date_obj = parseDateAndTime(input_date, input_time);
    // Convert local timezone to UTC time for submission to the server.
    // $: if (isValid(input_date_obj)) start_date = zonedTimeToUtc(input_date_obj).toUTCString();
    $: if (isValid(input_date_obj)) start_date = input_date_obj.toUTCString();

    let details_size: ResizeObserverSize[] | null = null;
    function getReactiveGrid(size: ResizeObserverSize[] | null) {
        if (!size || size.length == 0) return "";
        const w = size[0].inlineSize
        let n = w > 500 ? 4 : (w > 300 ? 2 : 1);
        n = 2;
        let style = `grid-template-columns: repeat(${n}, minmax(0, 1fr));`;
        return style;
    }

    let media_size: ResizeObserverSize[] | null = null;
    const minimum_media_width = 500;
    function getMediaReactiveGrid(size: ResizeObserverSize[] | null) {
        if (!size || size.length == 0) return "";
        const w = size[0].inlineSize
        let n = w > minimum_media_width ? 3 : 1;
        let style = `grid-template-columns: repeat(${n}, minmax(0, 1fr));`;
        return style;
    }

    let zoom_authorization_window;

    function openZoomAuthorizationWindow() {
        if (zoom_authorization_window && !zoom_authorization_window.closed) {
        zoom_authorization_window.focus();
        } else {
        zoom_authorization_window = window.open(
        '/authorize_zoom', 
        "Xert - Zoom Authorization",
        "width:30vh; height: 50vh"
        );
        }
        
        updateZoomAuthorization(zoom_authorization_window);
    }

    let zoom_deauthorization_window;

    function openZoomDeauthorizationWindow() {
        if (zoom_deauthorization_window && !zoom_deauthorization_window.closed) {
        zoom_deauthorization_window.focus();
        } else {
        zoom_deauthorization_window = window.open(
        '/deauthorize_zoom', 
        "Xert - Zoom Deauthorization",
        "width:30vh; height: 50vh"
        );
        }
        
        updateZoomAuthorization(zoom_deauthorization_window);    
    }

    function updateZoomAuthorization(_window) {
        let timer = setInterval(function() { 
        if(_window.document.getElementById("close-zoom-authorization-window")) {
            setTimeout(function () {
                _window.close();
            }, 3000);
        }
        
        if(_window.closed) {
            clearInterval(timer);
            
            // Update Data
            window.fetch(`${xert.Sessions.urls.is_zoom_authorized}`, {
                method: 'get',
                credentials: "same-origin",
            })
            .then(response => response.json())
            .then(data => {
                is_zoom_authorized = data.is_zoom_authorized;
            }).catch(error=>{
                console.log(error)
            });
        }
        }, 1000);
    }

    let zoom_full_integration = getContext('zoom_full_integration');
    function getReactiveColumn(w, column_start) {
        let style = `grid-column: ${w > 300 ? column_start+"/-1" : "span 1"};`
        return style;
    }

    let repeat_items = [
        { label: $_('sessions.editor.labels.repeat-none'), value: "none", },
        { label: $_('sessions.editor.labels.repeat-weekly'), value: "weekly", },
        { label: $_('sessions.editor.labels.repeat-daily'), value: "daily", },
    ];
    let selected_repeat = repeat_type == null ? repeat_items[0] : repeat_items.find(v=>repeat_type == v.value);
    $: repeat_type = selected_repeat == null ? undefined : selected_repeat.value;
</script>

<!--
<form bind:this={image_form} method="post" enctype="multipart/form-data" id="image_form"/>
-->

<div class="flex-container"> <form bind:this={session_form} method="post" action="javascript:;">
  <!--Slider bind:this={slider} bind:progress={slider_progress}-->
  <coarse-grid class="col-fill grid-outline">
    <grid-4 bind:borderBoxSize={details_size} style={getReactiveGrid(details_size)} class="col">

    <h4 class="bold col-fill">
      {$_("sessions.scheduler.details")}
    </h4>

    <div class="time-selector col-fill">
      <row-container>
        <MyInput 
          label={$_("sessions.editor.labels.start_date")}
          type="date"
          required={true}
          min="{dateString(new Date())}"

          input={input_date}
          bind:output={input_date}
        />
      </row-container>
      <row-container>
        <MyInput 
          label={$_("sessions.editor.labels.start_time")}
          type="time"
          required={true}
          validate={(e)=>{
            let input = e.target;

            let date = parseDateAndTime(input_date, input.value);

            if (!isValid(date)) {
              input.setCustomValidity($_("sessions.errors.invalid_input"));
            } else {
              input.setCustomValidity("");
            }

            return input.value;
          }}

          input={input_time}
          bind:output={input_time}
        />
      </row-container>
    </div>

    <row-container class="col-fill">
      <span>{$_("sessions.editor.labels.repeat")}</span>
      <div class="my-input">
      <Select isClearable={false} bind:value={selected_repeat} items={repeat_items} />
      </div>
    </row-container>

    <row-container class="col-fill"> <span>{$_("sessions.editor.labels.session_type")}</span>
      <div class="my-input">
      <Select isClearable={false} bind:value={selected_session_type} items={session_type_items} />
      </div>
    </row-container>

    </grid-4>
  </coarse-grid>
    
  <coarse-grid style="padding-top: 24px;">
    {#if is_group_session}
    <div class="col-fill grid-outline">
      <h4 class="bold text-center">
        {$_("sessions.editor.sharing")}
      </h4>
      <row-container class="flex-row flex-centre"> <span class="margin-vcentre">{$_("sessions.editor.labels.community")}</span>
        <div class="my-input" style="margin: 10px; max-width: 300px;">
        <Select on:clear={()=>{
            console.log("community cleared ????");
            community = null;
          }} bind:value={selected_community} items={club_items} groupBy={(v)=>v.group} isMulti={false} bind:input={selected_community_input}/>
        </div>
      </row-container>
  
    {#if club_is_selected}
    <grid-3 class="grid-outline">
        <h4 class="bold">
          {#if allow_edit_users}
          {$_("sessions.editor.invite_members")}
          {:else}
          {$_("sessions.editor.group_members")} ({members?.length ?? 0})
          {/if}
        </h4>
        <radio-group class="flex-container flex-row flex-centre">
          {#if can_create_public}
            <input type="radio" id="public" name="invite" value="public" bind:group={sharing_type}>
            <label for="public">{$_('sessions.editor.labels.public')}</label> 
          {/if}
          <input type="radio" id="community" name="invite" value="community" bind:group={sharing_type}>
          <label for="community">{$_('sessions.editor.labels.invite-all')}</label> 
          <input type="radio" id="invite-only" name="invite" value="invite-only" bind:group={sharing_type}>
          <label for="invite-only">{$_('sessions.editor.labels.invite-only')}</label> 
        </radio-group>
    </grid-3>
    <div class="grid-outline">
      <ParticipantList {owner} {sharing_type} {allow_edit_users} {invited_users} {members} bind:users_to_invite={users_to_invite} {users_to_schedule} club_users={is_public ? [] : club_users} />
    </div>
    {/if}
    </div>
    {/if}
  
  </coarse-grid>

  <coarse-grid style="padding-top: 24px;">
    {#if is_group_session}
    <coarse-grid class="col-fill grid-outline">
      <grid-4 bind:borderBoxSize={media_size} style={getMediaReactiveGrid(media_size)} class="col">
        <row-container class="col-fill"> 
          <h4 class="bold">
            {$_("sessions.editor.labels.zoom")}
          </h4>
        </row-container>
        
          {#if zoom_full_integration}
            {#if is_zoom_authorized}
            <row-container>
              <br>
              <span class="content-center">
                {$_("sessions.editor.labels.autocreate_zoom")}
                <input style="margin-left:5px;" type="checkbox" bind:checked={zoom_autocreation}>
              </span>
            </row-container>
            <row-container>
              <br>
              <span class="content-center">
                <a on:click={openZoomDeauthorizationWindow}>
                  <i class="fa fa-chain-broken" aria-hidden="true"/>
                  {$_("sessions.editor.labels.deauthorize_zoom")}
                </a>
              </span>
            </row-container>
            {:else}
            <row-container class={ (media_size && media_size.length != 0 && media_size[0].inlineSize > minimum_media_width) ? "col-2": "" }>
              <span class="content-center">
                {$_("sessions.editor.labels.authorize_zoom")}
                <i title={$_("sessions.editor.labels.why_authorize_zoom")} data-placement="right" class="fa-solid fa-question-circle"/>
                :
                <button style="background-color:Transparent; border:none; outline:none;" on:click={openZoomAuthorizationWindow}>
                  <img style="height:1em; margin:1em; min-height:18px; min-width:80px;" alt="Zoom Logo" src="/assets/images/ZoomLogo.png"> 
                </button>
              </span>
            </row-container>
            {/if}
          {/if}
        {#if !zoom_autocreation}
        <row-container class="col-fill"> 
          <span>{$_("sessions.editor.labels.zoom_url")}</span>
          <input placeholder={$_("sessions.editor.labels.zoom_url_placeholder")} maxlength="{256}" bind:value={zoom_url}> 
          <br>
          <span class="subtext">{$_("sessions.editor.labels.zoom_url_recommendation_text")}</span>
          <ul>
            <li class="subtext">{$_("sessions.editor.labels.zoom_url_recommendation_1")}</li>
            <li class="subtext">{$_("sessions.editor.labels.zoom_url_recommendation_2")}</li>
          </ul>
          <span class="subtext">
            {$_("sessions.editor.labels.zoom_url_recommendation_more_info")}
            <a target="_session" href="https://support.zoom.us/hc/en-us/articles/202828525-Allow-participants-to-join-before-host">{$_("sessions.editor.labels.zoom_url_recommendation_more_info_title")}</a>
          </span>
        </row-container>
        {/if}
      </grid-4>

      {#if is_zoom_media}
        <img style="width:100%;" alt="Zoom Session Sample" src="/assets/images/ZoomSessionSample.png">
      {/if}
    </coarse-grid>
    {/if}
  </coarse-grid>

  <!--/Slider-->
</form></div>

<style lang="scss">
    // TODO: Figure out how to appy theme globally?
    @import './style/xert.scss';
  
    ::placeholder {
      opacity: 0.5;
    }
  
    .subtext {
      color: grey;
    }
  
    .content-center {
      position:relative; 
      //left:50%; 
      //transform:translate(-50%);
    }
    
    flex-container, .flex-container {
      display: flex;
      flex-direction: column;
      align-content: stretch;
  
      iframe {
        border: none;
      }
    }
  
    row-container, ul {
      //padding: 5px;
      display: flex;
      align-items: start;
      justify-content: flex-start;
      flex-wrap: wrap;
      flex-direction: column;
  
      > input, > .my-input {
        margin: 0;
        width: 100%;
      }
      textarea {
        flex-grow: 1;
        max-width: 100%;
        color: #4A4A4A;
        &:focus {
        }
      }
  
  
  
      .my-input {
        --height: 33.2px;
        --multiClearTop: 3px;
        --multiItemHeight: 22px;
        --clearSelectTop: 4px;
        --clearSelectBottom: 4px;
        --padding: 0.4em;
        --itemHoverBG: #4AA;
        --multiItemActiveBG: var(--color-xert-teal);
      }
  }
  grid-4 {
    > row-container {
        grid-column: span 2;
    }
  }
    grid-3 {
      display: grid;
      grid-gap: 16px;
      > row-container {
        grid-column: span 1;
      }
      grid-template-columns: repeat(3, minmax(0, 1fr));
      @media(max-width: $media-size-lg) {
        grid-template-columns: repeat(1, minmax(0, 1fr));
      }
    }
    .col {
      grid-column: span 2;
    }
    .col-fill {
      grid-column: span 4;
      //grid-column: 1 / -1;
  
    }
    
    .col-new {
      grid-column: 1;
    }
    .col-2 {
      grid-column: span 2;
    }
    .col-2-new {
      grid-column: 1 / span 2;
    }
  
    radio-group {
      grid-column: span 1;
      > input {
        margin: auto 0 auto 0;
      }
      > label {
        margin: auto 15px auto 5px;
      }
  
    }
  
    button.selecting_all {
      background-color: deepskyblue;
      color: white;
    }

    .time-selector {
      background-color: #eee;
      border-radius: 12px !important;
      padding: 24px;
    }
  
  </style>